
import { defineComponent } from 'vue';
import baseUrl from "@/api/base-url";
import magicCartTimer from "@/models/magic-cart-timer.js";
import prozisEventQueue from "../../../../../../../src-js/monitor-user-behaviour-2/prozis-event-queue.js";
import { configI18n } from '@/models/translations';
import MuffinLoader from "@/components/Muffin/Loader.vue";
import { storePdp } from "@/store/product-page";
//import request from "@/Utilities/httpRequest";
//import { clickOutside } from '@/api/vueDirectives';

export default defineComponent({
    name: 'HeaderLinks',
    components: {
        MagicCartModal: () => import('@/components/MagicCart/Modal.vue'),
        Favorites: () => import('@/components/Account/FavoritesDesktop.vue'),
        Login: () => import('@/components/Login/Login.vue'),
        DashboardDesktop: () => import('@/components/Account/Desktop/Dashboard.vue'),
        MiniCart: () => import('@/components/DesktopHeader/MiniCart.vue'),
        ShortUrl: () => import('@/components/Partners/ShortUrlDesktop.vue'),
        Help: () => import('@/components/DesktopHeader/Help/Help.vue'),
        //ProzisLive: () => import('@/components/Social/Live/ProzisLive.vue'),
        LiveTab: () => import('@/components/Social/Live/LiveTab.vue'),
        Chat: () => ({
            component: import('@/components/Chat/IndexDesktop.vue'), 
            loading: MuffinLoader,
            delay: 50,
            timeout: 5000
        }),
    },
    props: {
        user: {
            type: Object,
            default: null
        },
        cart: {
            type: Object,
            default: null
        },
        i18n: {
            type: Object,
            default: null
        },
        partner: {
            type: Object,
            default: null
        },
        openState: {
            type: Object,
            default: null
        },
        disableMiniCart: {
            type: Boolean,
            default: false
        },
        isClub: {
            type: Boolean,
            default: false
        },
        chat:{
            type: Object,
            default: undefined
        },
        magicCart: {
            type: Object,
            default: () => {
                return {
                    hasNewPromo: false,
                    interval: null,
                    open: false,
                    url: null,
                    icon: null
                }
            }
        },
        hasLive: {
            type: Boolean,
            default: false
        },
        hideModals: {
            type: Boolean,
            default: false
        },
    },
    data() {
        let openEventChat: any = null;
        return {
            activeElem: null,
            accountData: null,
            textSearchAjax: '',
            showCreateLink:true,
            updatedCartData: null,
            loginPropsData: null,
            firstTimeCartLoad: false,
            magicCartHasNewPromo: false,
            magicCartPromoData: null,
            isMiniCartClicked: false,
            prozisLiveData: null,
            liveWidget: null, // fullscreen + draggable video widget
            openEventChat,
            blockClickContent: false
            //firstMount: true
        };
    },
    mounted() {
        this.updatedCartData = this.cart; // not updating on mounted (not even with nexttick)

        //magic cart button show event
        // if(this.firstMount && !this.partner){
        //     this.firstMount = false;
        //     //prozisEventQueue.addEvent('magic-cart', 'show-btn', {icon: this.magicCartIcon}, true);
        // }

        // add event listeners (no need to remove event listeners, because if component 
        // is destroyed, page is being unloaded)
        const elem = this.$refs['headerLinks'];
        if(elem){
            elem.addEventListener('evtHeaderCart', this.onHeaderCart);
            elem.addEventListener('evtOpenLogin', this.onOpenLogin);
            elem.addEventListener('evtOpenHelp', this.onOpenHelp);
            elem.addEventListener('evtMenuIsOpen', () => {
                this.toggleElement(this.activeElem);
            });
            elem.addEventListener('evtMagicCartNewPromo', (event) => {
                //console.log('event evtMagicCartNewPromo received', event.detail);
                this.magicCartPromoData = event.detail.promos ? event.detail.promos : null;
                this.magicCartHasNewPromo = event.detail.hasNewPromo;
                if(event.detail.open === true && !this.activeElem){
                    this.toggleElement('magicCart', true);
                }
            });
        }

        if(this.openState){
            this.activeElem = this.openState.name;
            if(this.openState.name == 'login' && this.openState.data){
                this.loginPropsData = this.openState.data;
            }
        }

        const content = document.getElementById('content');
        if(content){
            content.addEventListener('click', (e) => {
                if(this.blockClickContent){
                    this.blockClickContent = false;
                }else{
                    this.toggleElement(this.activeElem);
                }
            });
        }

        this.magicCartHasNewPromo = this.magicCart.hasNewPromo;
        if(this.magicCart.interval){
            magicCartTimer.init(this.magicCart.interval, this.magicCart.url, this.getUrl('magic-cart'));
        }
        if(this.magicCart.open === true && !this.activeElem){
            this.loadAndOpenMagicCart();
        }

        let header = document.querySelector('#header');
        if(header){
            header.addEventListener('actionOpenChat', (e) => {
                this.blockClickContent = true;
                if(!this.hasUser){
                    this.toggleElement('login');
                }
                else if(this.activeElem != 'chat'){
                    this.toggleElement('chat');
                    this.openEventChat = e ?? null;
                }
            });
        }

        configI18n(this.i18n);
    },
    computed: {
        chatParams(){
            let params = this.chat;
            if(this.openEventChat){
                params.openEvent = this.openEventChat;
            }
            return this.chat;
        },
        chatMsgUnread(){
            return this.chatParams?.msgUnread ?? false;
        },
        hasCart(){
            return this.updatedCartData && this.updatedCartData.itemCount || (this.cart && this.cart.itemCount);
        },
        hasUser(){
            return this.user && this.user.name;
        },
        loginProps(){
            return {
                isDesktop: true,
                urlParams: this.loginPropsData?.urlParams,
                startPage: this.loginPropsData?.startPage,
            }
        },
        magicCartIcon(){
            return this.magicCart?.icon ?? 'prz-magic';
        },
    },
    watch: {
        cart: { // hotfix
            immediate: true,
            handler(value) {
                this.updatedCartData = value;
            }
        },
        hideModals:{
            immediate: true,
            handler(value) {
                if(value == true){
                    this.activeElem = null;
                }
            }
        }
    },
    methods: {
        getUrl(route: string){
            if(window.location.port == '8080'){
                // development mode
                switch(route){
                    case '':
                    case '/':
                        return 'mobile-homepage.html';
                    default:
                        //console.log('URL', 'https://'+window.location.hostname+process.env.VUE_APP_DEV_STORE+'/'+route);
                        return 'https://'+window.location.hostname+process.env.VUE_APP_DEV_STORE+'/'+route;
                }
            }
            return baseUrl.getUrl(route);
        },
        goto(route: string){
            window.location = this.getUrl(route);
        },
        toggleElement(elem: string, auto: boolean = false){
            //console.log('toggleElement: current / new', this.activeElem, elem);

            if(this.activeElem == elem){
                this.activeElem = null;
                this.closeAllTabsEvent();
            }
            else{
                this.activeElem = elem;
                if (this.activeElem && typeof VueEs6 !== "undefined") {
                    VueEs6.header.menu.closeMenu();
                }
            }
            
            // reset login props data
            this.loginPropsData = null;

            if(this.partner && this.partner.shortUrl && !this.partner.shortUrl.searchValue && this.activeElem == 'partner'){
                //Necessary when the user do a Search for send a text value to Short Url Generator
                this.searchUrlParamsPartners();
            }
            else if(this.activeElem == 'magicCart'){
                // magic cart is being open
                // reset magic cart "new promo" indicator
                this.magicCartHasNewPromo = false;
                magicCartTimer.pause();
                prozisEventQueue.addEvent('magic-cart', 'open', {mode: auto ? 'auto' : 'manual'}, true);
            }
            else if(elem == 'magicCart'){
                // magic cart is being closed
                magicCartTimer.resume();
                prozisEventQueue.addEvent('magic-cart', 'close', {}, true);
            }
        },
        magicCartClick(){
            //prozisEventQueue.addEvent('magic-cart', 'click', {icon: this.magicCartIcon}, true);
            this.toggleElement('magicCart');
        },
        searchUrlParamsPartners(){
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const text = urlParams.get('text');
            if(!text && this.partner.shortUrl && this.partner.shortUrl.controllerAction == 'catalogsearch'){
                this.showCreateLink = false;
            }else{
                const elem = document.getElementById("noResultsWrapper");
                if(elem){
                    this.showCreateLink = false;
                }else{
                    this.showCreateLink = true;
                }
                this.textSearchAjax = text ? text : '';
            }
        },
        updateCart(cartData = null) { // cartQty + total from mini cart.
            if(cartData) {
                this.updatedCartData = {
                    itemCount: cartData.itemCount,
                    value: cartData.value
                }
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateHeaderCartQty', cartData.itemCount);
                if(cartData.pointsInfo) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateImmersivePoints', cartData.pointsInfo);
                }
            }
        },
        closeAllTabsEvent(){
            try{
                let elem = this.$refs.headerLinks ?? null;
                if(elem){
                    (elem as HTMLElement).dispatchEvent(new CustomEvent('evtCloseAllTabs'));
                }
            }catch(e){}
        },
        onHeaderCart(e){
            // console.log('HeaderLinks component, onHeaderCart', e);
            // console.log('mini cart event', e.detail);
            if(!e.detail){
                return;
            }
            if(e.detail.updateAndOpen){
                this.toggleElement('cart');
                if(this.$refs.miniCart) {
                    this.$refs.miniCart.loadMiniCart(e.detail.refresh ? true : false);
                }
            } else if(e.detail.open && this.activeElem != 'cart'){
                //console.log('HeadeLinks component, open cart');
                this.toggleElement('cart');
            } else if(e.detail.close && this.activeElem == 'cart'){
                //console.log('HeadeLinks component, close cart');
                this.toggleElement('');
            }
        },
        onOpenLogin(e) {
            //console.log('open login:', e.detail);
            if(!e.detail){
                return;
            }

            if(e.detail.open){
                this.loginPropsData = {
                    urlParams: e.detail.params ? e.detail.params : null,
                    startPage: e.detail.startPage ? e.detail.startPage : null,
                }
                setTimeout(() => {
                    this.activeElem = 'login';
                }, 100)
            }
        },
        onOpenHelp(e) {
            this.toggleElement('help');
        },
        hideCallback(){
            this.activeElem = '';
            this.closeAllTabsEvent();
        },  
        openMiniCart(){
            if(!this.disableMiniCart && this.activeElem !== 'cart'){
                this.activeElem = 'cart';
                if(!this.firstTimeCartLoad && this.$refs.miniCart){
                    // use setTimeout because user may have clicked
                    setTimeout(() => {
                        if(!this.isMiniCartClicked){
                            this.firstTimeCartLoad = true;
                            this.$refs.miniCart.loadMiniCart();
                        }
                    }, 400);
                }
            }
        },
        onMiniCartClick(event){
            if(this.isMiniCartClicked){
                // already clicked, cancel navigation
                event.preventDefault();
            }
            else{
                // set prop to prevent multiple clicks
                this.isMiniCartClicked = true;
            }
        },
        async loadAndOpenMagicCart(){
            this.magicCartPromoData = await magicCartTimer.loadPromos(this.getUrl('magic-cart'));
            if(this.magicCartPromoData){
                this.toggleElement('magicCart', true);
            }
        },
    },
});
